// extracted by mini-css-extract-plugin
module.exports = {"btnPurpleCircleTransparent":"BtnPurpleCircleTransparent_btnPurpleCircleTransparent__3zvA0","icon":"BtnPurpleCircleTransparent_icon__1VjRk"};